import { render, staticRenderFns } from "./ReviewCustomerDetailsAddress.vue?vue&type=template&id=261bb964&"
import script from "./ReviewCustomerDetailsAddress.vue?vue&type=script&lang=js&"
export * from "./ReviewCustomerDetailsAddress.vue?vue&type=script&lang=js&"
import style0 from "./ReviewCustomerDetailsAddress.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src414009122/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('261bb964')) {
      api.createRecord('261bb964', component.options)
    } else {
      api.reload('261bb964', component.options)
    }
    module.hot.accept("./ReviewCustomerDetailsAddress.vue?vue&type=template&id=261bb964&", function () {
      api.rerender('261bb964', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/ReplacementWidget/ReviewCustomerDetailsAddress.vue"
export default component.exports